import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import themes from './theme';

import { useThemeModeStore } from './stores/useThemeModeStore';

export default function ThemeWrapper({
  children
}) {

  const mode = useThemeModeStore(
    state => state.mode
  );

  return (
    <ThemeProvider theme={themes[mode]}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );

}